//
//
//
//
//
//
//
//
//
//
//
export default {
  props: ['tableData'],
  computed: {
    allTableData: function allTableData() {
      return this.tableData;
    }
  },
  data: function data() {
    return {
      tableData: []
    };
  }
};